import Vue from 'vue';
import format from 'date-fns/format';

export const contractorsListingService = {
  async retrieveContractors(activeInactive, sortOrder, paginationParameters, searchParam) {
    return Vue.axios
      .get('/contractors/list', {
        params: {
          searchParam,
          activeInactive,
          ...sortOrder,
          ...paginationParameters
        }
      })
      .then(response => response.data);
  },
  async downloadContractorsXlsx(activeInactive, sortOrder) {
    const response = await Vue.axios({
      url: `/contractors/xlsx`,
      method: 'GET',
      params: {
        activeInactive,
        ...sortOrder
      },
      responseType: 'blob'
    });
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `Contractors-${format(new Date(), 'YYYY-MM-DD-HH-mm-ss')}.xlsx`);
    document.body.appendChild(link);
    link.click();
  },
  //Needs to change this function as pagination is not required for fetching total record
  async retrieveRecordCount(activeInactive, paginationParameters, searchParam) {
    return Vue.axios
      .get('/contractors/count-records', {
        params: {
          activeInactive,
          ...paginationParameters,
          searchParam
        }
      })
      .then(response => response.data);
  }
};
